/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.publicAmazonCatalogue.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class Meta(
    @SerialName("current_page")
    val currentPage: Int?,

    @SerialName("from")
    val from: Int?,

    @SerialName("path")
    val path: String?,

    @SerialName("per_page")
    val perPage: Int?,

    @SerialName("to")
    val to: Int?
)
